import { configureStore } from '@reduxjs/toolkit';
import toastSlice from './slices/toast.slice';
import authSlice from './slices/auth.slice';
import { authApi } from './apis/AuthApi';
import { iconsApi } from './apis/IconsApi';
import { adminsApi } from './apis/AdminsApi';
import { ushersApi } from './apis/UshersApi';
import { eventsApi } from './apis/EventApi';
import { sessionApi } from './apis/SessionApi';
import { attendeeApi } from './apis/AttendeeApi';
import attendeeSlice from './slices/attendee.slice';
import scannerReaderSlice from './slices/scannerReader.slice';
import { helperApi } from './apis/helperApi';
import { partnersApi } from './apis/PartnerApi';
import { surveyApi } from './apis/SurveyApi';
import { questionsApi } from './apis/QuestionsApi';
import { choicesApi } from './apis/ChoicesApi';
import { mailTasksApi } from './apis/MailTassksApi';

const store = configureStore({
	reducer: {
		toast: toastSlice.reducer,
		scannerReader: scannerReaderSlice.reducer,
		auth: authSlice.reducer,
		registration: attendeeSlice.reducer,
		[iconsApi.reducerPath]: iconsApi.reducer,
		[authApi.reducerPath]: authApi.reducer,
		[adminsApi.reducerPath]: adminsApi.reducer,
		[ushersApi.reducerPath]: ushersApi.reducer,
		[eventsApi.reducerPath]: eventsApi.reducer,
		[sessionApi.reducerPath]: sessionApi.reducer,
		[attendeeApi.reducerPath]: attendeeApi.reducer,
		[helperApi.reducerPath]: helperApi.reducer,
		[partnersApi.reducerPath]: partnersApi.reducer,
		[surveyApi.reducerPath]: surveyApi.reducer,
		[questionsApi.reducerPath]: questionsApi.reducer,
		[choicesApi.reducerPath]: choicesApi.reducer,
		[mailTasksApi.reducerPath]: mailTasksApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat([
			authApi.middleware,
			iconsApi.middleware,
			adminsApi.middleware,
			ushersApi.middleware,
			eventsApi.middleware,
			sessionApi.middleware,
			attendeeApi.middleware,
			helperApi.middleware,
			partnersApi.middleware,
			surveyApi.middleware,
			questionsApi.middleware,
			choicesApi.middleware,
			mailTasksApi.middleware,
		]),
});

export default store;

export type StoreRootState = ReturnType<typeof store.getState>;
